import { CurrentCardService } from '@addins/core/core';
import { CallcardStampsService } from '@addins/core/journal';
import { CardPageService } from '@addins/core/singlecallcard/services/card-page/card-page.service';
import { Component } from '@angular/core';
import { NavParams } from '@ionic/angular';
import { CallcardService } from '@services/callcard/callcard.service';
import { Events } from '@services/events/events.service';
import { NavService } from '@services/navigation/navigation.service';
import { ViewConfigurationService } from '@services/view-configuration/view-configuration.service';
import { AddinView } from '@techwan/ionic-core';
import { CallcardDetailBaseComponent } from '../../components/callcard-detail-base/callcard-detail-base.component';
import { CardStampsPopoverService } from '../../services/card-stamps-popover/card-stamps-popover.service';
import { MediaToolsProviderService } from '../../services/media-tools-provider/media-tools-provider.service';

@Component({
  templateUrl: 'page-detail-view.component.html',
  styleUrls: ['page-detail-view.component.scss']
})
@AddinView({
  name: 'PageView'
})
export class PageDetailViewComponent extends CallcardDetailBaseComponent {
  hasMediaTools: boolean;

  constructor(
    private readonly mediaTools: MediaToolsProviderService,
    nav: NavParams,
    cardService: CallcardService,
    events: Events,
    navService: NavService,
    view: ViewConfigurationService,
    current: CurrentCardService,
    _pages: CardPageService,
    public readonly stamps: CardStampsPopoverService,
    private callcardStamps: CallcardStampsService
  ) {
    super(nav, cardService, events, navService, view, current, _pages);
  }

  ngOnInit() {
    super.ngOnInit();
    this.hasMediaTools = this.mediaTools.getMediaTools().length > 0;
  }

  addMedia() {
    this.mediaTools.open(this.currentCallCard);
  }

  refreshStamp() {
    this.callcardStamps.$refreshStamps.emit();
  }
}
